import { render, staticRenderFns } from "./MatchDetail.vue?vue&type=template&id=a8b0999c&scoped=true&"
import script from "./MatchDetail.vue?vue&type=script&lang=js&"
export * from "./MatchDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b0999c",
  null
  
)

export default component.exports